module.exports = __webpack_public_path__ + "assets/img/5_1341_big.e88db076.jpg";